// extracted by mini-css-extract-plugin
export default {"paymentinfoBody":"paymentInfo_paymentinfoBody__ghvNU","paymentinfoBeforebg":"paymentInfo_paymentinfoBeforebg__uAc4c","paymentinfoInput":"paymentInfo_paymentinfoInput__UNhmZ"};